import { Component, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";

import { ExternalpageSingle } from "../../../class/externalpage-single";
import { ImageService } from "../../../shared/services/image.service";
import { AuthenticationService } from "../../../shared/services/authentication.service";

@Component({
  selector: "app-page-school",
  templateUrl: "./page-school.component.html",
  styleUrls: ["./page-school.component.scss"],
  standalone: false,
})
export class PageSchoolComponent extends ExternalpageSingle implements OnInit {
  override readonly maxRelatedDataItems = 6;
  readonly window = window;

  private readonly route = inject(ActivatedRoute);
  readonly imageService = inject(ImageService);
  private readonly authService = inject(AuthenticationService);

  public relatedData: any[] = [];

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((routeParams) => {
        this.onIdChange();
        this.loadSingle(routeParams["id"]);
      });
  }
}
